import PropTypes from 'prop-types';
import React from 'react';

// components
import { Panel, PanelBody, PanelHeader } from '../_panel';

const SimplePanel = (props) => {
  return (
    <Panel className={ props.className }>
      <PanelHeader>
        <span className='panel__header__label'>{ props.header }</span>
      </PanelHeader>
      <PanelBody>
        { props.children }
      </PanelBody>
    </Panel>
  );
};

SimplePanel.propTypes = {
  header: PropTypes.string.isRequired
};

export default SimplePanel;



// WEBPACK FOOTER //
// ./app/components/shared/panel/_SimplePanel.jsx